import MosaicContainer from "./container";

export default MosaicContainer;
